import { render, staticRenderFns } from "./CertificateWarning.vue?vue&type=template&id=33e383ca"
import script from "./CertificateWarning.vue?vue&type=script&lang=js"
export * from "./CertificateWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e383ca')) {
      api.createRecord('33e383ca', component.options)
    } else {
      api.reload('33e383ca', component.options)
    }
    module.hot.accept("./CertificateWarning.vue?vue&type=template&id=33e383ca", function () {
      api.rerender('33e383ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/CertificateWarning.vue"
export default component.exports